import React from 'react';
import PropTypes from 'prop-types';
import { StickyContainer } from 'react-sticky';
import { connectToStores } from 'fluxible-addons-react';
import { get } from 'lodash';
import { Helmet } from 'react-helmet';
import ArticleTemplate from '../../Article/Template';
import MicrositeTemplate from '../../Microsites/Template';
import ApplicationStore from '../../../stores/ApplicationStore';
import DocumentStore from '../../../stores/DocumentStore';
import initSampleBox from '../../../browser/sampleBox';
import setInnerHtmlHooks from '../../../browser/setInnerHtmlHooks';
import ContentRenderer from '../../ContentRenderer';
import StickyNav from '../../StickyNav';
import FeedbackWidget from '../../FeedbackWidget';
import metrics from '../../../browser/metrics';

class ArticlePage extends React.Component {
  constructor(props) {
    super(props);
    this.templates = {
      default: ArticleTemplate,
      microsite: MicrositeTemplate
    };
  }
  componentDidMount() {
    const { doc } = this.props;
    const docIsLoaded = !!(doc && (doc.html || doc.meta));
    if (docIsLoaded) {
      this.sendArticleViewedEvent();
    }
  }

  componentDidUpdate(prevProps) {
    const newDoc = this.props.doc;
    const prevDoc = prevProps.doc;

    const newDocUrl = newDoc && newDoc.meta && newDoc.meta.url;
    const prevDocUrl = prevDoc && prevDoc.meta && prevDoc.meta.url;

    if (newDocUrl && newDocUrl !== prevDocUrl) {
      this.sendArticleViewedEvent();
    }
  }

  handleContentRender = (elem) => {
    this.executeEmbeddedScripts();
    initSampleBox();
    setInnerHtmlHooks(elem, this.props.isFramedMode);
  }

  executeEmbeddedScripts = () => {
    $('script', this.content).each((idx, item) => {
      if (item.src) {
        $(item).remove();
        const el = document.createElement('script');
        el.src = item.src;
        document.body.appendChild(el);
      } else {
        $.globalEval(item.text || item.textContent || item.innerHTML || '');
      }
    });
  }

  sendArticleViewedEvent = () => {
    metrics.track('view:article:feedbackExperiment');
  }

  render() {
    const {
      doc,
      url
    } = this.props;

    const templateName = get(this.props, 'doc.meta.template') || 'default';
    const Template = this.templates[templateName];

    const docHasToc = !!get(this.props, 'doc.meta.toc');
    const docIsLoaded = !!(doc && (doc.html || doc.meta));

    const showSidebarFeedback = url.indexOf('/docs/microsites') !== 0 && url.indexOf('/docs/videos') !== 0;

    return (
      <div
        className={`
          docs-article
          doc-with-sidebar
          ${docHasToc ? 'docs-with-toc' : ''}
        `}
      >
        <Helmet>
          <meta name="robots" content={get(doc, 'meta.sitemap') !== false ? 'all' : 'noindex, nofollow'} />
        </Helmet>
        <StickyContainer>
          <StickyNav title={doc && doc.meta && doc.meta.title} />
          <div className="document">
            <Template
              doc={doc}
              url={url}
              contentReady={docIsLoaded}
              renderContent={(templateDoc) => (
                <div ref={e => (this.content = e)}>
                  <ContentRenderer
                    html={templateDoc.html}
                    meta={templateDoc.meta}
                    afterRender={this.handleContentRender}
                  />
                </div>
              )}
            />
            {docIsLoaded && showSidebarFeedback && <FeedbackWidget />}
          </div>
        </StickyContainer>
      </div>
    );
  }
}

ArticlePage.propTypes = {
  doc: PropTypes.object,
  url: PropTypes.string.isRequired,
  isFramedMode: PropTypes.bool.isRequired
};

export default connectToStores(ArticlePage, [
  ApplicationStore,
  DocumentStore
], (context, { currentRoute: { url } }) => ({
  isFramedMode: context.getStore(ApplicationStore).isFramedMode(),
  doc: context.getStore(DocumentStore).getDocument(url),
  url
}));
